import React, { useMemo } from "react";
import { CateringOrder } from "../../shared/models/CateringOrder";
import { getFulfillmentDateTime } from "./utils/sortCateringOrder";
import { format } from "date-fns";

interface ReminderModalProps {
  open: boolean;
  orders: CateringOrder[];
  onClose: () => void;
  title?: string;
}

const ReminderModal: React.FC<ReminderModalProps> = ({ open, orders, onClose, title }) => {
  const sortedOrders = useMemo(() => {
    return [...orders].sort((a, b) => {
      const fdtA = getFulfillmentDateTime(a);
      const fdtB = getFulfillmentDateTime(b);
      if (!fdtA || !fdtB) return 0;
      return fdtA.getTime() - fdtB.getTime();
    });
  }, [orders]);

  if (!open) return null;

  return (
    <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title || "Today's Catering Orders"}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            {sortedOrders.length === 0 ? (
              <p>No orders for today.</p>
            ) : (
              <table className="table table-sm table-hover">
                <thead>
                  <tr>
                    <th>Order No</th>
                    <th>Fulfillment Date & Time</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedOrders.map((order) => {
                    // Display the date nicely and append the original fulfillmentTime string
                    const baseDate = order.fulfillmentDate ? new Date(order.fulfillmentDate) : null;
                    const dateStr = baseDate ? format(baseDate, "MMM dd, yyyy") : "N/A";
                    const timeStr = order.fulfillmentTime ? ` ${order.fulfillmentTime}` : "";
                    return (
                      <tr key={order.id}>
                        <td>{order.id}</td>
                        <td>{dateStr}{timeStr}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReminderModal;
